import { Form, Select } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

interface SelectEnrichmentListFiltersProps {
  enrichmentListId: string;
  value: string[];
  errors: any;
  isCampaignExist: boolean;
  showLabel?: boolean;
  onChange: (value: string[]) => void;
  getFilters: (params: any) => void;
  clearFilters: () => void;
}

export const SelectEnrichmentListFilters = ({ enrichmentListId, value, onChange, getFilters, errors, isCampaignExist, clearFilters, showLabel = true }: SelectEnrichmentListFiltersProps) => {
  const { filters, filtersLoading, filtersMetaData: { has_next } } = useSelector((state: any) => state.leadEnrichment);
  const [currentPage, setCurrentPage] = useState(1);


  useEffect(() => {
    if (!isCampaignExist && enrichmentListId) {
      clearFilters();
      setCurrentPage(1);
      getFilters({ lead_enrichment: enrichmentListId, page: 1, page_size: 10 });
    } else {
      clearFilters();
      getFilters({ id__in: value });
    }
  }, [enrichmentListId]);

  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e;
    const scrollElement = target as HTMLDivElement;
    const { scrollTop, scrollHeight, clientHeight } = scrollElement;
    const isBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (isBottom && has_next && !filtersLoading && !isCampaignExist) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      getFilters({
        lead_enrichment: enrichmentListId,
        page: nextPage,
      });
    }
  };

  return (
    <Form.Item name="enrichment_filters_ids" validateStatus={errors.enrichment_filters_ids ? 'error' : ''} help={errors.enrichment_filters_ids ? errors.enrichment_filters_ids?.toString() : ''} label={showLabel ? 'Filters:' : ''}>
      <Select
        placeholder="Select filters for the enrichment list"
        value={value}
        defaultValue={value}
        disabled={isCampaignExist}
        onChange={onChange}
        optionLabelProp="label"
        mode="multiple"
        loading={filtersLoading}
        onPopupScroll={handlePopupScroll}
        options={filters.map((filter: any) => ({
          label: filter.filter_name || filter.name,
          value: filter.id,
        }))}
      />
    </Form.Item>
  )
}

